<template>
  <section class="edit-container flex">
    <div class="flex-1">
      <div class="flex flex-sb-center">
        <h2>Edit Claim Request</h2>
        <div>
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            @click="handlerSave">Save</v-button>
        </div>
      </div>
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
      >
        <div class="form-container">
          <div class="form-item">
            <span>Accident Date</span>
            <v-date-picker v-model="formData.accident_date" />
          </div>
          <template v-if="isMotor">
            <div class="form-item">
              <span class="pd-b-0 ">Involved Driver Last Name</span>
              <el-form-item prop="contact_person">
                <v-input
                  v-model="formData.isrd_lst_nm"
                  class="mg-t-3" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span class="pd-b-0 ">Involved Driver First Name</span>
              <el-form-item prop="contact_person">
                <v-input
                  v-model="formData.isrd_fst_nm"
                  class="mg-t-3" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Accident Driver HKID Number</span>
              <el-form-item prop="contact_person">
                <v-input
                  v-model="formData.id_no"
                  uppercase
                  placeholder="A123456(3), please input A1234563"
                />
              </el-form-item>
            </div>
          </template>
          <template v-if="isTravelOrPA">
            <div class="form-item">
              <span class="pd-b-0 ">Accident Insured</span>
              <!--            <span class="fs-12 color-gray ">If there is another person responsible, please file another claim.</span>-->
              <el-form-item
                ref="id_no"
                :rules="rules.select"
                prop="id_no">
                <v-select
                  v-model="formData.id_no"
                  :list="list"
                  value-key="id_no"
                  :labelKey="'lst_nm'"
                  show-name
                  is-string
                  :labelSecondKey="'fst_nm'"
                  class="mg-t-3" />
              </el-form-item>
            </div>
          </template>
          <template v-if="!isMotor&&!isTravelOrPA">
            <div class="form-item">
              <span>Accident Insured</span>
              <el-form-item prop="isrd_nm">
                <v-input
                  v-model="formData.isrd_nm"
                  disabled />
              </el-form-item>
            </div>
          </template>
          <div class="form-item">
            <span>Contact Person</span>
            <el-form-item
              ref="contact_person"
              prop="contact_person"
            >
              <v-input v-model="formData.contact_person" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Contact Number</span>
            <el-form-item
              ref="contact_no"
              prop="contact_no"
            >
              <v-input
                v-model="formData.contact_no" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Brief Description Of The Accident</span>
            <v-input
              v-model="formData.description"
              type="textarea"
              :rows="4" />
          </div>
          <h3>Documents</h3>
          <div class="mg-b-15">
            <span
              v-for="(item, index) in claimFormList"
              :key="index"
              class="font-16 blue pointer block"
              @click="downloadClaimForm(item.url)">{{ item.name }}</span>
            <!-- <v-button
              type="warning"
              @click="downloadClaimForm">Download Claim Form</v-button> -->
          </div>
          <section v-if="formData.other_file && formData.other_file.length > 0">
            <file-container
              v-for="(item, index) in formData.other_file"
              :key="index"
              :fileData="item"
              :edit="true"
              :otherData="{
                index
              }"
              @uploadSuccess="handlerUploadSuccess"
              @delete="deleteOtherFile">
              <!-- document{{ index+1 }} -->
            </file-container>
          </section>
          <v-upload
            @uploadSuccess="handlerUploadSuccess" />
        </div>
      </el-form>
    </div>
    <ticket-remark
      class="mg-l-20"
      :ticket-id="ticketId"
    ></ticket-remark>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import FileContainer from '@/views/components/file-container'
import {editTicketClaim, getClaimForm} from '@/api/ticket'
import MixinRules from '@/mixins/rules'
import TicketRemark from '@/views/tickets/components/ticket-remark'

export default {
  name: 'EditClaim',
  components: {
    TicketRemark,
    FileContainer
  },
  mixins: [MixinOptions,MixinRules],
  props: {
    ticketId: [Number, String],
    customerId: Number,
    form: {
      type: Object,
      default: () => ({})
    },
    detailData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        accident_date: '',
        contact_person: '',
        contact_no: '',
        description: '',
        other_file: [],
        id_no:'',
        isrd_nm:'',
        isrd_fst_nm:'',
        isrd_lst_nm:''
      },
      // claimFormUrl: '',
      claimFormList: []
    }
  },
  computed:{
    list(){
      let {nm_traveler_list,nm_pa_list} = this.detailData||{}
      return Number(this.productId)==14?nm_traveler_list:nm_pa_list
    },
    productId(){
      let {product_id} = this.form||{}
      return Number(product_id)
    },
    isMotor(){
      return this.productId == 11
    },
    isTravelOrPA(){
      let {type_of_insured} = this.detailData||{}
      return type_of_insured==2&&this.productId==18||[14].includes(this.productId)
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler(val) {
        let {accident_date} = val||{}
        let date = ''
        if(accident_date){
          let time = accident_date.split('-')
          date =`${time[2]}-${time[1]}-${time[0]}`
        }
        this.formData = Object.assign(this.formData, JSON.parse(JSON.stringify(val)))
        this.formData.accident_date = date||''
        let {isrd_nm} = val
        let name = isrd_nm.split(' ')
        this.formData.isrd_lst_nm  =name[0]
        this.formData.isrd_fst_nm   =name[1]
        if(val.order_id) {
          this.network().getClaimForm()
        }

      }
    }
  },
  methods: {
    handleCancel(){
      this.$emit('cancel')
      this.$emit('refresh')
    },
    handlerSave() {
      this.$refs.form.validate((valid, rules) => {
        if (valid) {
          this.network().editTicketClaim()
        }else{
          this.scrollToValidDom(rules)
          this.$message({
            type: 'warning',
            message: '請填寫需填的信息'
          })
        }
      })
    },

    deleteOtherFile({ index }) {
      this.formData.other_file.splice(index, 1)
    },
    // 上傳完文件
    handlerUploadSuccess({ data, otherData }) {
      const { index = '' } = otherData
      const { name, id } = data
      if(index !== '') {
        this.$set(this.formData.other_file, index, data)
      }
      else {
        this.formData.other_file.push(data)
      }
    },
    downloadClaimForm(url) {
      window.open(url, '_blank')
      // if(!this.claimFormUrl) {
      //   await this.network().getClaimForm()
      // }
      // window.open(this.claimFormUrl, '_blank')
    },
    network() {
      return {
        editTicketClaim: async () => {
          if(this.isMotor){
            let {isrd_lst_nm,isrd_fst_nm} = this.formData||{}
            this.formData.isrd_nm = `${isrd_lst_nm} ${isrd_fst_nm}`
          }
          if(this.isTravelOrPA){
            let {id_no} = this.formData||{}
            this.list.some(item=>{
              if(item.id_no==id_no){
                this.formData.id_type = item.id_type
                this.formData.isrd_nm = `${item.lst_nm} ${item.fst_nm}`
              }
            })
          }
          const { data } = await editTicketClaim({
            ticket_id: this.ticketId,
            // customer_id: this.customerId,
            ...this.formData
          })
          this.$emit('save')
        },
        getClaimForm: async () => {
          const { data } = await getClaimForm({
            order_id: this.form.order_id,
            hideLoading: true
          })
          this.claimFormList = data.claim_form_download
          // this.claimFormUrl = data.download_url
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-container {
    position: relative;
    padding: 15px;
    width: 100%;
    .abs-top-right {
        top: 20px;
        right: 15px;
    }
    .form-container {
        width: 370px;
    }
}
</style>
